import React from 'react';
import { ChevronDown } from 'lucide-react';
import { useTheme } from '../contexts/ThemeContext';

/**
 * FilterSelect - A themed dropdown select component for admin filters
 * Uses the filters settings from ThemeContext for consistent styling
 */
const FilterSelect = ({ 
  value, 
  onChange, 
  options = [], 
  placeholder = 'Select...',
  className = '',
  'data-testid': testId,
  ...props 
}) => {
  const { adminTheme } = useTheme();
  const filterBgColor = adminTheme?.filters?.backgroundColor || '#D4F6FF';
  const maxWidth = adminTheme?.filters?.maxClosedWidth || '200px';

  return (
    <div className={`relative ${className}`} style={{ maxWidth }}>
      <select
        value={value}
        onChange={onChange}
        className="appearance-none w-full pl-3 pr-8 py-2.5 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2"
        style={{ backgroundColor: filterBgColor }}
        data-testid={testId}
        {...props}
      >
        {options.map((option, idx) => (
          <option key={option.value ?? idx} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      <ChevronDown className="absolute right-2 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400 pointer-events-none" />
    </div>
  );
};

export default FilterSelect;
